module.exports = __webpack_public_path__ + "static/media/hr_doc3.b8cdae0b.JPG";